import {useMemo} from 'react';

//IRAC official Ratings Definitions list
//list from https://globalratings.com/ratings-definitions/#
const IRACOfficialRatings = [
	'ACB', //Australian Classification Board
	'ClassInd', //Classificação Indicativa
	'ESRB',
	'GRAC',
	'PEGI',
	'Russia',
	'USK',
	'Generic' //IARC Generic
];

const isIRACSupportedRatings = (ratingName?: string) => {
	if (!ratingName) {
		return false;
	}
	return IRACOfficialRatings.map((rating) => rating.toLowerCase()).includes(
		ratingName.toLowerCase()
	);
};

export const useGlobalRatingLink = (ratingSystem?: string) => {
	const url = process.env.NEXT_PUBLIC_RATING_URL;

	const ratingLink = useMemo(() => {
		if (!ratingSystem || !url || !isIRACSupportedRatings(ratingSystem)) {
			return;
		}
		return `${url}#${ratingSystem.toLowerCase()}`;
	}, [ratingSystem, url]);

	return ratingLink;
};
